module.exports = __webpack_public_path__ + "static/media/routes07.175eb428.webp";